import { useContext } from "react";
import { ProfileWithRoles } from "src/api/types";
import { ClinicianContext } from "./ClinicianProvider";

export function useClinician<T>(selector: (clinician: ProfileWithRoles) => T) {
  const clinician = useContext(ClinicianContext);

  if (clinician == null) {
    throw new Error("useClinician is used outside ClinicianProvider");
  }

  return selector(clinician);
}
